__turbopack_context__.v({
  "colorify-fill": "Icons-module-scss-module__VNTYlq__colorify-fill",
  "colorify-stroke": "Icons-module-scss-module__VNTYlq__colorify-stroke",
});
